import { render, staticRenderFns } from "./GetInsulationMaterials.vue?vue&type=template&id=db8c7086"
import script from "./GetInsulationMaterials.vue?vue&type=script&lang=js"
export * from "./GetInsulationMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports